import type { FooterTemplate } from '@iheartjane/data-access';
import { Card, Flex, Typography } from '@iheartjane/reefer';
import { Controller, useFormContext } from 'react-hook-form';

import { LayoutWireframe } from './FooterWireframes';

import styles from './Footer.module.css';

export const LayoutSection = () => {
  const { control } = useFormContext<FooterTemplate>();

  return (
    <Card
      border="grays-ultralight"
      className={styles['sectionCard']}
      id="layout"
    >
      <Flex p={40} flexDirection="column" gap={24}>
        <Typography variant="h2-semibold">Layout</Typography>
        <Typography>
          Choose a layout for your footer on desktop. It will adjust
          responsively on mobile.
        </Typography>

        <Flex gap={24}>
          <Controller
            name="layout"
            control={control}
            render={({ field }) => (
              <>
                <Flex
                  flexDirection="column"
                  alignItems="left"
                  width="100%"
                  border={
                    field.value === 'align_left' ? 'purple' : 'grays-light'
                  }
                  borderRadius="lg"
                  p={16}
                  as="label"
                  className={styles['layoutOptionCard']}
                >
                  <input
                    type="radio"
                    name="layout"
                    value="align_left"
                    checked={field.value === 'align_left'}
                    onChange={() => field.onChange('align_left')}
                    className={styles['radioInput']}
                    aria-label="Left aligned layout"
                  />
                  <LayoutWireframe
                    alignment="align_left"
                    selected={field.value === 'align_left'}
                  />
                  <Typography variant="body-semibold">Left aligned</Typography>
                  <Typography color="grays-mid">
                    The logo and call-to-action are on the left. Links are on
                    the right.
                  </Typography>
                </Flex>

                <Flex
                  flexDirection="column"
                  alignItems="left"
                  width="100%"
                  border={
                    field.value === 'align_right' ? 'purple' : 'grays-light'
                  }
                  borderRadius="lg"
                  p={16}
                  as="label"
                  className={styles['layoutOptionCard']}
                >
                  <input
                    type="radio"
                    name="layout"
                    value="align_right"
                    checked={field.value === 'align_right'}
                    onChange={() => field.onChange('align_right')}
                    className={styles['radioInput']}
                    aria-label="Right aligned layout"
                  />
                  <LayoutWireframe
                    alignment="align_right"
                    selected={field.value === 'align_right'}
                  />
                  <Typography variant="body-semibold">Right aligned</Typography>
                  <Typography color="grays-mid">
                    The logo and call-to-action are on the right. Links are on
                    the left.
                  </Typography>
                </Flex>
              </>
            )}
          />
        </Flex>
      </Flex>
    </Card>
  );
};
